import type { AllRouteEndpoints } from "../routeTypes";
export const openAiLiquidAssistantWithDiffsCacheKeys: AllRouteEndpoints[] = [];
